import { AdminActivityLog } from "@/types";
import { ColumnDef } from "@tanstack/react-table";

export const adminActivityColumns: ColumnDef<AdminActivityLog>[] = [
  { accessorKey: "id", header: "Log ID" },
  { accessorKey: "adminName", header: "Admin" },
  { accessorKey: "action", header: "Action" },
  {
    accessorKey: "timestamp",
    header: "Time",
    cell: ({ row }) => new Date(row.original.timestamp).toLocaleString("en-IN"),
  },
];
